import React from 'react';
import { CTAButton } from './CTAButton';
import { useIntersectionObserver } from './useIntersectionObserver';
export function FinalCTA() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-light py-16 md:py-24 border-y border-white/5" data-id="element-36">
      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-37">
        <div className="space-y-6 text-gray-200 mb-12" data-id="element-38">
          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-39">
            Has trabajado demasiado duro para seguir dejando ir dinero que es
            tuyo.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-40">
            La información en este eBook no es secreta. Es pública. Está en los
            archivos del IRS.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed text-gray-400" data-id="element-41">
            Pero está escrita para abogados, no para ti.
          </p>

          <p className="text-2xl md:text-3xl font-heading font-bold text-gold-primary" data-id="element-42">
            Hoy eso cambia.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-43">
            Por menos de lo que cuesta un combo de comida rápida, tienes acceso
            a los 3 hacks que pueden cambiarte el próximo cheque de taxes — y
            recuperar lo que perdiste en los últimos años.
          </p>
        </div>

        <div className="text-center mb-12" data-id="element-44">
          <CTAButton text="SÍ — QUIERO MI COPIA AHORA MISMO" className="w-full md:w-auto text-xl py-6 px-10" data-id="element-45" />
          <p className="mt-4 text-sm text-gray-400 font-medium" data-id="element-46">
            Descarga inmediata • Pago seguro • Empieza a leer en los próximos 3
            minutos
          </p>
        </div>

        <div className="h-px bg-white/10 my-10" data-id="element-47"></div>

        <div className="space-y-6 text-gray-200" data-id="element-48">
          <p className="text-xl md:text-2xl leading-relaxed text-gray-400" data-id="element-49">
            El IRS no te va a llamar para decirte lo que te deben.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-50">
            Pero tú ya sabes que existe.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-51">
            Y ahora sabes que tienes poco tiempo.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-52">
            La pregunta no es si este dinero existe.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed font-bold text-gold-primary" data-id="element-53">
            La pregunta es: ¿lo vas a reclamar tú o lo vas a dejar ir otro año
            más?
          </p>
        </div>
      </div>
    </section>;
}